import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Login from 'pages/Login/Login';

import classes from './Evaluator.module.css';

const Evaluator = () => {
  const { idActivity } = useParams();
  const dataUser = useSelector(state => state.userInfo);

  return (
    <>
      {dataUser.data.usuario ? (
        <iframe
          className={classes.evaluatorContainer}
          src={
            idActivity
              ? `https://evaluator-ia.mayahii.com/campus/userActivity/${idActivity}`
              : 'https://evaluator-ia.mayahii.com/campus/myActivities'
          }
          frameBorder="0"
        />
      ) : (
        <Login prevUrl="evaluator" />
      )}
    </>
  );
};

export default Evaluator;
